
export class Qualification { // TODO: SAKP musi rozszerzyć definicje o i18n lub sami musimy tu znać i mapować z name
    constructor(public readonly id: number, public readonly name: string, public readonly description: string) { }
}
